export default __webpack_public_path__ + "static/media/logo-odc-conference.a401c9d8.svg";